import React, { useEffect, useState } from 'react';

import moment from 'moment';
import axios from 'axios';
import { CKEditor } from 'ckeditor4-react';
import Modal from '@material-ui/core/Modal';

import i18n from '../i18n';
import { withTranslation, Trans, withNamespaces } from 'react-i18next';

import '../css/IndpNewTask.css';
import { urgencies } from './urgencies';
import CommonCustomToaster from './CommonCustomToaster';

const IndpNewTask = ({ 
    jwt,
    user_id, 
    api_origin,
    api_url, 
    indp_call,
    user_name, 
    element_id, 
    agent_list, 
    element_data, 
    element_type, 
    get_internal_comments, 
}) => {

    const [ open, setOpen ] = useState(false);
    const [ agent, setAgent ] = useState('2952');
    const [agentList, setAgentList] = useState();
    const [ message, setMessage ] = useState(false);
    const [ newSubject, setNewSubject ] = useState('');
    const [ newComment, setNewComment ] = useState('');
    const [ agentName, setAgentName ] = useState('Mario');
    const [ showToaster, setShowToaster ] = useState(false);
    const [ toasterSuccess, setToasterSuccess ] = useState(false);
    const [ selectedUrgency, setSelectedUrgency ] = useState('1');

    const getAgents = async () => {
    
        let agntData = await axios.get(api_url+'/admin/agents',
        {   
            headers: {
                "Accept": "application/json, text/javascript, */*; q=0.01",
                "Authorization": jwt
            }
        });
        
        if (agntData) {
            setAgentList(agntData.data.data);
        }
    }

    if(indp_call){
        useEffect(() => {
            getAgents();
        },[])
    }

    const handleSend = async (e) => {

        if(indp_call){

            setShowToaster(false);
            setMessage('Subject is requried');
            let newURL = `${api_url}/admin/internal-comments`;
            
            if(newSubject != ''){
    
                setMessage('Comment text is requried');
    
                if(newComment != ''){
    
                    let data = {
                        "to_user_id": agent,
                        "subject": newSubject,
                        "to_user_name": agentName,
                        "comment_text": newComment,
                        "urgency_id": selectedUrgency,
                    }
            
                    if(element_type == 'comment'){
                        data.is_communication = 1;
                        data.parent_comment_id = "";
                    }
                    
                    setToasterSuccess(true);
                    setMessage('Comment added');
                    const postData = JSON.stringify(data);
                    setShowToaster(true);
            
                    let eleData = await axios.post(newURL, postData,
                    {
                        headers: {
                            "Accept": "application/json, text/javascript, */*; q=0.01",
                            "Authorization": jwt
                        }
                    });
                    
                    if (eleData) {
                        setAgent('2952');
                        setNewComment('');
                        setNewSubject('');
                        setAgentName('Mario');
                        setSelectedUrgency('1');
                        
                        closeToaster();
                        handleClose();
                    }
    
                }else{
                    closeToaster();
                    setShowToaster(true);
                }
    
            }else{
                closeToaster();
                setShowToaster(true);
            }

        }else{

            setShowToaster(false);
            setMessage('Subject is requried');
            let newURL = `${api_url}/admin/internal-comments`;
            
            if(newSubject != ''){
    
                setMessage('Comment text is requried');
    
                if(newComment != ''){
    
                    let data = {
                        "to_user_id": agent,
                        "subject": newSubject,
                        "to_user_name": agentName,
                        "comment_text": newComment,
                        "urgency_id": selectedUrgency,
                        // is_communication 1
                    }
            
                    if(element_type == 'document'){
                        data.document_id = element_id;
                    }else if(element_type == 'list'){
                        data.list_id = element_id;
                    }else if(element_type == 'rma'){
                        data.rma_document_id = element_id;
                    }else if(element_type == 'target-discount'){
                        data.target_discount_id = element_id;
                    }else if(element_type == 'comment'){
                        data.is_communication = 1;
                        data.parent_comment_id = element_id;
                    }else {
                        data.parent_comment_id = element_id;
                    }
                    
                    const postData = JSON.stringify(data);
            
                    let eleData = await axios.post(newURL, postData,
                    {
                        headers: {
                            "Accept": "application/json, text/javascript, */*; q=0.01",
                            "Authorization": jwt
                        }
                    });
                    
                    if (eleData) {
                        handleClose();
                        setAgent('2952');
                        setNewComment('');
                        setNewSubject('');
                        setAgentName('Mario');
                        get_internal_comments();            
                        setSelectedUrgency('1');
                    }
    
                }else{
                    closeToaster();
                    setShowToaster(true);
                }
    
            }else{
                closeToaster();
                setShowToaster(true);
            }

        }

    }

    const handleSelectAgent = (e) => {
        setAgent(e.target.value);
        setAgentName(e.target.options[e.target.selectedIndex].getAttribute('data-name'));
    }
    
    const handleChangeUrgency = (e) => {
        setSelectedUrgency(e.target.value);
    }
    
    const handleChangeNewComment = (data) => {
        console.log("Comment change: ", data);
        setNewComment(data);
    }

    const handleChangeNewSubject = (e) => {
        setNewSubject(e.target.value);
    }

    const handleClose = () => {
        setOpen(false);
    };
    
    const handleOpen = () => {
        setOpen(true);
    };

    const closeToaster = () => {
        setTimeout(() => {
            setShowToaster(false);
        }, 3000);
    }

    return(

        <>
            <div className="bottom-btn"><button className="btn btn-grayb btn-w100 btn-w100" onClick={handleOpen}>New Task</button></div>

            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                style={{zIndex: "9999"}}
            >
                <div className="modal-dialog modal-lg comment-popup full-screen-popup">
                    <div className="modal-content">
                        {/* Modal body */}
                        <div className="modal-body">
                            <div className="indp-chat-history">
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className="indp-card-body">
                                            <div className="indp-card-body-header">
                                                {indp_call ?
                                                    <>
                                                        <ul><li><Trans>User:</Trans><span>{user_name}</span></li></ul>
                                                        <ul><li><Trans>Date:<span>{moment(Date.now()).format("D-MMM-YYYY")}</span></Trans></li></ul>
                                                    </> 
                                                : 
                                                    <>
                                                        <ul>
                                                            <Trans><li>Project:<span>{element_data?.project_name}</span></li></Trans>
                                                            <Trans><li>User:<span>{user_name}</span></li></Trans>
                                                        </ul>
                                                        <ul>
                                                            <Trans><li>Ref:<span>{element_data?.reference_id}</span></li></Trans>
                                                            <Trans><li>Date:<span>{moment(Date.now()).format("D-MMM-YYYY")}</span></li></Trans>
                                                        </ul>
                                                    </>
                                                }
                                                <ul>
                                                    {indp_call ? 
                                                        <li>
                                                            <i className="fa fa-comments-o" aria-hidden="true"></i>
                                                            <Trans>Message/comment</Trans>
                                                            <Trans><b>TO</b></Trans>
                                                            <div className="form-group">
                                                                <select 
                                                                    className="form-control" 
                                                                    value={agent}
                                                                    onChange={(e) => handleSelectAgent(e)}
                                                                >
                                                                    {agentList?.map((agent, agindx) => 
                                                                        <option key={agindx} data-name={`${agent.name}`} value={`${agent.webuser_id}`}>
                                                                            {agent.name} {/*${agent.agent_id}*/}
                                                                        </option>
                                                                    )}
                                                                </select>
                                                            </div>
                                                        </li>
                                                    :
                                                        <li>
                                                            <i className="fa fa-comments-o" aria-hidden="true"></i>
                                                            <Trans>Message/comment</Trans>
                                                            <Trans><b>TO</b></Trans>
                                                            <div className="form-group">
                                                                <select 
                                                                    className="form-control" 
                                                                    value={agent}
                                                                    onChange={(e) => handleSelectAgent(e)}
                                                                >
                                                                    {agent_list?.map((agent, agindx) => 
                                                                        <option key={agindx} data-name={`${agent.name}`} value={`${agent.webuser_id}`}>
                                                                            {agent.name} {/*${agent.agent_id}*/}
                                                                        </option>
                                                                    )}
                                                                </select>
                                                            </div>
                                                        </li>
                                                    }

                                                    <li>
                                                        <Trans><b>Urgency</b></Trans>
                                                        <div className="form-group">
                                                            <select 
                                                                className="form-control" 
                                                                value={selectedUrgency}
                                                                onChange={(e) => handleChangeUrgency(e)}
                                                            >
                                                                {urgencies?.map((urg, urgindx) => 
                                                                    <option key={urgindx} value={urg.id}>{urg.value}</option>
                                                                )}
                                                            </select>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div className="inner-card-body">
                                                <div className="form-group">
                                                    <div className="row">
                                                        <label className="col-sm-2 col-form-label"><Trans>Subject</Trans></label>
                                                        <div className="col-sm-10">
                                                            <input
                                                                id="subject" 
                                                                type="text" 
                                                                className="form-control"                                                                 
                                                                placeholder="Subject"
                                                                value={newSubject}
                                                                onChange={(e) => handleChangeNewSubject(e)}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <CKEditor 
                                                            debug={true} 
                                                            initData={newComment}
                                                            onChange={evt => handleChangeNewComment(evt.editor.getData())}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            
                                            <div className="indp-card-footer text-right" >
                                                <hr></hr>
                                                <div className='row'>
                                                    <div className='col-md-12'>
                                                        <button className="btn btn-grayb btn-w100" onClick={()=>handleSend()}><Trans>Send</Trans></button>
                                                        <button type="button" className="btn btn-danger btn-w100" onClick={()=>handleClose()} ><Trans>Cancel</Trans></button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div> 
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>

            {showToaster ?
                <CommonCustomToaster headContent={message} success={toasterSuccess} />
            : ""}
        </>

    );

}

export default withTranslation()(IndpNewTask);